import React from 'react';

const SignupErr = ({ err }) => {

    return (
        <div id="af_errors" className="errors">
            {
                err.map((error, index) => {
                    return (
                        <div className="alert-danger mb-2" key={index}>
                            <p>{error}</p>
                        </div>
                    )
                })
            }
        </div>
    )

}

export default SignupErr
